var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './DropDown.module.scss';
import { DropDown } from 'src/ui/components/DropDown/DropDown';
import { IDENTIFIER_DROPDOWN_OPTIONS } from 'src/ui/components/DropDown/constants';
import { Icons } from 'src/ui/components/Icons/Icons';
export var DropDownMenu = function (props) {
    var label = props.label, options = props.options, onOptionClick = props.onOptionClick;
    var handleOnOptionClick = function (event, option) {
        event.stopPropagation();
        onOptionClick(option);
    };
    return (_jsx(DropDown, __assign({ label: label }, { children: _jsx("ul", __assign({ "data-test": IDENTIFIER_DROPDOWN_OPTIONS }, { children: options.map(function (option) { return (_jsxs("li", __assign({ className: styles.dropDownImmersedOptionItem, onClick: function (event) { return handleOnOptionClick(event, option); } }, { children: [option.value, option.icon && _jsx(Icons, { icon: option.icon })] }), option.id)); }) })) })));
};
